import styled from 'styled-components'
import { LargeLink } from '@chegg-wt/core/theme/sunkist/link'
import { BaseProjectItem } from './ProjectListItem/styled'

export const SortContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 10px;
`

export const ProjectListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  margin-left: 10px;
  margin-bottom: 32px;
  div:last-child {
    margin-bottom: 0;
  }
`

export const CreateProjectContainer = styled(BaseProjectItem)`
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
`

export const CreateProjectButton = styled.button`
  ${LargeLink};
  padding: 17px 0 15px;
  flex-grow: 1;
  background: inherit;
`
